import React from 'react';
import {observer} from 'mobx-react';
import m from 'moment';

import SinglePersonView from './SinglePersonView';

function MultiPersonView({persons, store}) {
  const isSameDay = m(store.startDate).isSame(m(store.endDate), 'day');
  if (isSameDay) {
    persons.map(person => person.setOpen(true));
  } else {
    persons.map(person => person.setOpen(false));
  }


  return (
    <div>
      { persons.map(person => {
        return (
          <SinglePersonView
            key={person.id}
            person={person}
            store={store}
          />
        )
      })}
    </div>
  );
}

export default observer(MultiPersonView);



// WEBPACK FOOTER //
// ./src/views/Beeper/Components/MultiPersonView.js